module.exports = __webpack_public_path__ + "img/plus.50c35182.svg";